
export default function About() {
  return (
    <section id="about" className="py-16 sm:py-20 lg:py-28 bg-sage-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-20 items-center">
          {/* Photo Column */}
          <div className="relative">
            <div className="relative w-full max-w-md mx-auto lg:mx-0">
              {/* Decorative elements */}
              <div className="absolute -top-3 sm:-top-4 -left-3 sm:-left-4 w-20 sm:w-24 h-20 sm:h-24 border-2 border-sage-200 rounded-2xl sm:rounded-3xl"></div>
              <div className="absolute -bottom-3 sm:-bottom-4 -right-3 sm:-right-4 w-24 sm:w-32 h-24 sm:h-32 bg-sage-100 rounded-2xl sm:rounded-3xl -z-10"></div>

              {/* Main photo */}
              <div className="relative w-full h-[480px] sm:h-[560px] rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=beautiful%20young%20woman%20content%20creator%20sitting%20in%20stylish%20new%20york%20city%20apartment%20with%20large%20windows%20natural%20soft%20morning%20light%20wearing%20chic%20casual%20outfit%20smiling%20warmly%20holding%20coffee%20cup%20cozy%20feminine%20interior%20decor%20plants%20and%20books%20warm%20tones%20professional%20lifestyle%20portrait%20photography%20editorial%20style&width=500&height=700&seq=aboutfem1&orientation=portrait"
                  alt="Alex Rivera - NYC UGC Creator"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Floating badge */}
              <div className="absolute -right-3 sm:-right-4 top-10 sm:top-12 bg-white rounded-xl sm:rounded-2xl shadow-lg px-3.5 sm:px-5 py-3 sm:py-4 flex items-center gap-2 sm:gap-3">
                <div className="w-8 sm:w-10 h-8 sm:h-10 flex items-center justify-center bg-sage-100 rounded-full">
                  <i className="ri-heart-fill text-sage-500 text-base sm:text-lg"></i>
                </div>
                <div>
                  <p className="text-xs sm:text-sm font-display font-bold text-gray-900">2M+</p>
                  <p className="text-[10px] sm:text-xs font-sans text-gray-500">Followers</p>
                </div>
              </div>

              {/* Floating badge bottom */}
              <div className="absolute -left-3 sm:-left-4 bottom-12 sm:bottom-16 bg-white rounded-xl sm:rounded-2xl shadow-lg px-3.5 sm:px-5 py-3 sm:py-4 flex items-center gap-2 sm:gap-3">
                <div className="w-8 sm:w-10 h-8 sm:h-10 flex items-center justify-center bg-sage-100 rounded-full">
                  <i className="ri-star-fill text-sage-500 text-base sm:text-lg"></i>
                </div>
                <div>
                  <p className="text-xs sm:text-sm font-display font-bold text-gray-900">Top 1%</p>
                  <p className="text-[10px] sm:text-xs font-sans text-gray-500">NYC Creator</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div>
            <span className="inline-block text-xs font-display font-semibold uppercase tracking-[3px] text-sage-500 mb-3 sm:mb-4">
              About Me
            </span>

            <h3 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-gray-900 mb-6 sm:mb-8 leading-tight tracking-tight">
              Authentic Stories,<br />
              <span className="font-serif italic text-sage-600">Real Connections</span>
            </h3>

            <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-5 leading-relaxed">
              Hey, I&apos;m Alex! A passionate content creator born and raised in the heart of New York City. With over five years of experience crafting user-generated content for leading brands, I specialize in creating authentic narratives that resonate with diverse audiences.
            </p>

            <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-5 leading-relaxed">
              My approach blends strategic thinking with creative execution — delivering content that not only looks beautiful but drives measurable results. From beauty and fashion to lifestyle and wellness, I bring the energy and diversity of NYC into every project.
            </p>

            <p className="text-xs sm:text-sm text-gray-600 mb-8 sm:mb-10 leading-relaxed">
              I believe the best content comes from genuine connection. That&apos;s why every collaboration starts with understanding your brand&apos;s story and finding the most authentic way to share it with the world.
            </p>

            {/* Stats */}
            <div className="flex items-center gap-6 sm:gap-8 mb-8 sm:mb-10">
              <div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-display font-bold text-sage-500">150+</div>
                <div className="text-[10px] sm:text-xs text-gray-500 mt-1 font-display uppercase tracking-wider">Projects</div>
              </div>
              <div className="w-px h-10 sm:h-12 bg-sage-200"></div>
              <div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-display font-bold text-sage-500">80+</div>
                <div className="text-[10px] sm:text-xs text-gray-500 mt-1 font-display uppercase tracking-wider">Brands</div>
              </div>
              <div className="w-px h-10 sm:h-12 bg-sage-200"></div>
              <div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-display font-bold text-sage-500">5+</div>
                <div className="text-[10px] sm:text-xs text-gray-500 mt-1 font-display uppercase tracking-wider">Years in NYC</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 px-6 sm:px-7 py-3 sm:py-3.5 bg-gradient-to-r from-sage-500 to-caramel-400 text-white rounded-full font-display font-medium hover:from-sage-600 hover:to-caramel-500 transition-all cursor-pointer whitespace-nowrap shadow-md text-sm"
              >
                Work With Me
                <i className="ri-arrow-right-line"></i>
              </a>
              <button
                className="inline-flex items-center justify-center gap-2 px-6 sm:px-7 py-3 sm:py-3.5 bg-white text-gray-800 rounded-full font-display font-medium hover:bg-sage-50 transition-all cursor-pointer whitespace-nowrap shadow-md border border-sage-200 text-sm"
              >
                <i className="ri-download-line text-sage-500"></i>
                Media Kit
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
